export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Final2_13.ba2ecd90.jpg";